import { DevelopmentTicket } from './development-ticket';

export interface FeatureNote {
  featureNoteId: string;
  sectionHeader: string;
  developmentTickets: DevelopmentTicket[];
  featureName: string;
  body: string;
  order?: number;
}
